import React from "react";

import "./kin-settings-image.scss";
import { observer, inject } from "mobx-react";
import AvatarUpload, { AvatarUploadType } from "../avatar-upload/avatar-upload";
import { computed } from "mobx";

import deleteIcon from "../../images/trash-2.svg";
import { IKinStore } from "../../stores/kinStore";

/**
 * Profile image props and store
 *
 * @interface IKinSettingsImageProps
 */
interface IKinSettingsImageProps {
  name: string;
  image: string;
  kinStore?: IKinStore;
}

/**
 * Component to render the image uploading component or editing an existing image
 *
 * @class KinSettingsImage
 * @extends {React.Component<IKinSettingsImageProps, {}>}
 */
@inject("kinStore")
@observer
class KinSettingsImage extends React.Component<IKinSettingsImageProps, {}> {
  @computed get editing() {
    return this.props.kinStore!.editingKin;
  }

  /**
   * Default render method
   *
   * @returns
   * @memberof KinSettings
   */
  render() {
    return (
      <div className="b-kin-settings-image">
        <AvatarUpload
          uploadType={AvatarUploadType.Kin}
          editMode={this.editing}
          size={120}
          name={this.props.name}
          image={this.props.image}
        />
        <div className="e-col m-auto">
          {this.editing ? (
            <div onClick={() => this.props.kinStore!.removePhoto()} className="e-remove-image">
              Remove image <img src={deleteIcon} alt="Remove Avatar" />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default KinSettingsImage;
